// extracted by mini-css-extract-plugin
export var cartContainer = "_g7-4";
export var gray = "_g7-1";
export var itemContainer = "_g7-2";
export var itemDetails = "_g7-3";
export var strong = "_g7-0";